export async function wfetch() {
    try {
        const res = await fetch(...arguments);

        if (!res.ok) throw new Error(`Response status: ${res.status}`);

        const data = await res.json();

        return {
            url: res.url,
            status: res.status,
            data,
        };
    } catch (e) {
        console.error(e);
        return null;
    }
}
